import { render, staticRenderFns } from "./supplier-activity-buttons.vue?vue&type=template&id=4b8b2541"
import script from "./supplier-activity-buttons.vue?vue&type=script&lang=js"
export * from "./supplier-activity-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports